import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import LookSidebar from "../lookNavigation/lookSideBar/lookSideBar";
import {setLookPageOpened} from "../../../actions/lookFunctions";
import {ROUTES} from "../../../routes";
import LookRoomsMain from "./lookRoomsMain";

const LookRooms = (props) => {

  const {setLookPageOpened, history, hideOverlay} = props;

  const popupCloseClick = () => {
    setLookPageOpened(""); // turn button inactive
    hideOverlay(() => {
      // if (!window.location.hash.includes("login") && !window.location.hash.includes("look")) {   // fade out && router change after
      //   history.push(ROUTES.home);
      // }
      history.push(ROUTES.home);
    });
  }

  return (
    <div className="ll">
      <div className="ll-body ll-body--rooms ll-body--with-sidebar">
        <LookRoomsMain hideOverlay={hideOverlay}/>
      </div>
      <LookSidebar popupCloseClick={popupCloseClick}/>
    </div>
  )
};

const mapStateToProps = () => {
  return {

  };
};

const mapDispatchToProps = {
  setLookPageOpened
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookRooms)
)

